import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { log } from '@atlassian/mpac-utils';
/**
 * Fetches license information for a given cloud ID.
 *
 * @param {String} mpacBaseUrl - The base URL for the MPAC API
 * @param {String} cloudId - The cloud ID to fetch license information for
 * @returns Promise<LicenseInformation> - License information data
 */
export const getLicenseInformation = async (mpacBaseUrl, cloudId, onSuccess, onFailure) => {
  try {
    const url = "".concat(mpacBaseUrl, "/gateway/api/xflow/").concat(cloudId, "/license-information");
    const response = await fetchOk(url);
    if (onSuccess) onSuccess();
    return response.json();
  } catch (error) {
    log.error("Error fetching license information for cloud-id: ".concat(cloudId), error);
    if (onFailure) onFailure();
    throw error;
  }
};